var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"payment"},[_c('form',{ref:"form",attrs:{"action":_vm.url,"method":"post"}},_vm._l((_vm.data),function(val,key){return _c('input',{key:key,attrs:{"type":"hidden","name":key},domProps:{"value":val}})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }